import { usePush } from '@glyph/core';
import { Button, Card, CardHeader, Note } from '@glyph/ui';

/** "Notifications on this device": the home-screen app + Web Push, gated like email (per-unit arming). Cloud only. */
export function PushSetupCard({ className }: { className?: string }) {
  const p = usePush();
  if (!p.cloud) return null;
  const meta = p.state === 'on' ? 'ON' : p.state === 'busy' ? '…' : p.state === 'denied' ? 'BLOCKED' : p.state === 'unsupported' ? 'N/A' : 'OFF';
  const body = (() => {
    switch (p.state) {
      case 'unsupported':
        return <Note>This browser cannot receive push notifications. On a phone, open the console in Safari or Chrome.</Note>;
      case 'needs_install':
        return <Note tone="accent">On iPhone, add this page to the Home Screen first (Share → Add to Home Screen), open it from there, then enable notifications.</Note>;
      case 'disabled_on_server':
        return <Note tone="warn">Push is not configured on this cloud yet (GLYPH_VAPID_* keys).</Note>;
      case 'denied':
        return <Note tone="warn">Notifications are blocked for this site in the browser settings. Allow them there, then try again.</Note>;
      case 'on':
        return <Note tone="ok">This device gets one notification when a unit goes offline and one when it is back, plus unit alerts while it is connected.</Note>;
      default:
        return <Note>{p.standalone ? 'Installed as an app.' : 'Tip: add this page to your home screen for an app icon.'} Enable to get alerts on this device.</Note>;
    }
  })();
  return (
    <Card className={className}>
      <CardHeader title="Notifications on this device" meta={meta} metaTone={p.state === 'on' ? 'ok' : p.state === 'denied' ? 'warn' : undefined} />
      <div className="flex flex-col gap-3 border-t border-line px-4 py-3">
        {body}
        {p.error && <Note tone="warn">{p.error}</Note>}
        <div className="flex gap-2">
          {p.state === 'off' && (
            <Button variant="primary" size="responsive" onClick={() => void p.enable()}>
              Enable notifications
            </Button>
          )}
          {p.state === 'on' && (
            <Button size="responsive" onClick={() => void p.disable()}>
              Turn off on this device
            </Button>
          )}
          {(p.state === 'denied' || p.state === 'needs_install') && (
            <Button size="responsive" onClick={() => void p.refresh()}>
              Check again
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
